<template>
  <div class="w-full">
    <!-- eslint-disable max-len -->
    <div
      class="p-8 cursor-pointer bg-gray border-2 border-gray hover:border-theme1 expand-transition heading-bar rounded-t-tight flex items-center shadow-lg"
      :class="{ 'bg-theme1 border-theme1': open }"
      @click="open = !open"
    >
      <h2
        class="text-transition text-3 md:text-2 select-none leading-none"
        :class="{ 'text-white': open }"
        v-text="title"
      />
      <CoreIcon
        class="ml-4 h-5 white select-none icon-transition"
        :class="{ 'icon-open' : open }"
        icon="chevronDown"
        :black="!open"
      />
    </div>
    <div
      :style="contentStyle"
      class="h-0 height-transition rounded-b-tight shadow-lg"
      :class="{
        'overflow-hidden': !open
      }"
    >
      <div
        ref="content"
        class="rounded-b-tight border-b-2 border-l-2 border-r-2 border-theme1 p-8 bg-gray shadow-lg"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoreExpand',

  props: {
    title: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    open: false,
  }),

  computed: {
    contentStyle() {
      // ensure this.open is traversed before mounted too
      // https://stackoverflow.com/a/51699388/5669813

      // Do mothing here
      // eslint-disable-next-line no-unused-vars
      const { open } = this;

      // eslint-disable-next-line no-underscore-dangle
      if (!this._isMounted) return {};

      const height = this.open ? `${this.$refs.content.offsetHeight + 1}px` : '0px';
      return { height };
    },
  },

  watch: {
    open(open) {
      this.$emit('open', open);
    },
  },
};
</script>

<style scoped>
.expand-transition {
  transition-property: border-color, background-color;
  transition-duration: var(--transition-short);
  transition-timing-function: var(--transition-ease);
}

.text-transition {
  transition-property: color;
  transition-duration: var(--transition-short);
  transition-timing-function: var(--transition-ease);
}

.height-transition {
  transition-property: height;
  transition-duration: var(--transition-long);
  transition-timing-function: var(--transition-ease);
}

/* .icon-transition {
  transition-property: transform;
  transition-duration: var(--transition-short);
  transition-timing-function: var(--transition-ease);
} */

.icon-open {
  transform: rotate(180deg);
}
</style>
